import axios from "@/plugins/axios";

let url = "/api/v1/nshop/orders";

/** @typedef {import('../../../../store/nshop').NshopOrder} $NshopOrder */

export const orders = {
    /**
     * @param {Partial<$NshopOrder>} data
     * @returns {Promise<{ order: $NshopOrder }>}
     */
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
};

export default orders;
